import { Box, IconButton, Stack } from '@mui/material';
import { TrashIcon } from '@phosphor-icons/react';
import { useId } from 'react';

import { useReactFlowViewContext } from '../../../../context/context';
import { BlockValueTemplateInnerField } from '../FlowTemplate';

interface BlockTextArrayItemFieldProps {
  fieldName: string;
  placeholder: string;
  onDelete: () => void;
}

export function BlockTextArrayItemField(props: BlockTextArrayItemFieldProps) {
  const { fieldName, placeholder, onDelete } = props;
  const id = useId();
  const { isEditable } = useReactFlowViewContext();

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Box flex={1}>
        <BlockValueTemplateInnerField
          fieldId={id}
          fieldName={fieldName}
          label={placeholder}
          placeholder={placeholder}
        />
      </Box>
      {isEditable && (
        <IconButton
          onClick={() => {
            onDelete();
          }}
          aria-label="Delete Item"
        >
          <TrashIcon />
        </IconButton>
      )}
    </Stack>
  );
}
